export const menuList = [
  {
    label: 'Allgemeine Geschäftsbedingungen',
    handle: '/pages/allgemeine-geschaftsbedingungen',
    style: ' ',
  },
  {
    label: 'Versand-und Ruckgabebedingungen',
    handle: '/pages/versand-und-ruckgabebedingungen',
    style: '',
  },
  {
    label: 'Datenschutzbestimmungen',
    handle: '/pages/datenschutzbestimmungen',
    style: '',
  },
  // {
  //   label: 'Geschenkbedingungen',
  //   handle: '/pages/geschenkbedingungen',
  //   style: '',
  // },
];
